import { KeyValueModel } from "model/api";
import { EnumOrigemEmissao } from "model/enums/enum-origem-emissao";

export const OrigemEmissaoMock: KeyValueModel[] = [
    new KeyValueModel(EnumOrigemEmissao.PROPRIO, "Próprio"),
    new KeyValueModel(EnumOrigemEmissao.TERCEIROS, "Terceiro"),
];
